import React, { useContext } from "react"
import Select from "react-select"
import { shorString } from "../helpers"
import { MENU_OPTION } from "../const"
import { toTitleCase } from "../../../../../shared/helpers"
import { components } from "react-select"
import AppContext from "../../../../../shared/AppContext"

export const FrameCols = (props) => {
  return <div style={props.style}>{props.children}</div>
}

export const Image = (props) => {
  return <img src={props.src} width="60" />
}

export const Name = (props) => {
  return (
    <div className="favorite-name">{shorString(props.text, props.length)}</div>
  )
}

export const Title = (props) => {
  return (
    <div className="favorite-title">{shorString(props.text, props.length)}</div>
  )
}

export const Description = (props) => {
  return <p>{shorString(props.children, props.length)}</p>
}

export const Menu = (props) => {
  const { trackEvent } = useContext(AppContext)
  const options = [
    {
      value: MENU_OPTION.SHARE,
      label: toTitleCase(MENU_OPTION.SHARE),
      icon: "fas fa-share",
    },
    {
      value: MENU_OPTION.MOVE,
      label: toTitleCase(MENU_OPTION.MOVE + " To"),
      icon: "fas fa-file-export",
    },
    {
      value: MENU_OPTION.DELETE,
      label: toTitleCase(MENU_OPTION.DELETE),
      icon: "far fa-trash-alt",
      color: "#ff5656",
    },
  ]

  return (
    <div className="react-select-menu__container">
      <Select
        styles={{
          menu: (provided) => ({
            ...provided,
            width: "auto",
            right: 0,
            minWidth: 120,
          }),
          option: (provided, state) => {
            return {
              ...provided,
              cursor: "pointer",
              backgroundColor: state.isFocused ? "#f1f1f1" : null,
              color: state.data.color || "#325f7d",
            }
          },
        }}
        components={{
          ValueContainer: ValueContainer,
          Control: Control,
          Option: Option,
          DropdownIndicator: null,
          IndicatorSeparator: null,
        }}
        isMenuOpen={true}
        onChange={(value) => {
          props.onSelect(value)
          trackEvent("Favorite Menu Option", {
            selected: value.label,
            location: props.trackingLocation,
            favorite: {
              favoriteId: props.favoriteId,
              name: props.name,
              description: props.description,
            },
          })
        }}
        isSearchable={false}
        options={options}
      />
    </div>
  )
}

//// react select components

export const ValueContainer = ({ children, ...props }) => {
  // only display the input and not the label
  return (
    <components.ValueContainer {...props}>
      {children[1]}
    </components.ValueContainer>
  )
}

export const Control = ({ children, innerProps }) => {
  return (
    <div {...innerProps} className="react-select-control">
      {children}
      <i className="fas fa-ellipsis-h" style={{ color: "#4f758f" }}></i>
    </div>
  )
}

export const Option = ({ data, ...props }) => {
  return (
    <components.Option {...props} data={data} className="react-select-option">
      <i className={data.icon} style={{ paddingRight: ".8rem" }}></i>
      {data.label}
    </components.Option>
  )
}

export const FormButtomGroup = (props) => {
  const { className = "", style } = props
  return (
    <div className={`formButtonGroup ${className}`} style={style}>
      {props.children}
    </div>
  )
}
export const DeleteFavoriteWrap = (props) => {
  const { className = "", style } = props
  return (
    <div className={`favorite-delete ${className}`} style={style}>
      {props.children}
    </div>
  )
}

export const Message = (props) => {
  const { className = "" } = props
  return <p className={`message ${className}`}>{props.children}</p>
}
